import _ from 'lodash';
import { IGameConfig } from './sharedTypes';

let siteGame = '';

if (typeof RIO_SITE_GAME !== 'undefined') {
  // frontend
  siteGame = RIO_SITE_GAME;
} else {
  // backend
  const { sites } = require('../common/sites');
  siteGame = sites.getSite().game;
}

export let gameConfig: IGameConfig;

export function getGameConfig<T extends IGameConfig>(): T {
  const config = require(`./${siteGame}/index`).default as T;
  gameConfig = config;
  return config;
}

// only for testing
export const _setConfig = <T extends IGameConfig>(config: T) => {
  gameConfig = config;
};
